import styles from './Card.module.css';

export default function Card ({ title, value, subtitle }){
    return (
        <div className={styles.card}>
            <h3>{title}</h3>
            <span className={styles.cardBigText}>{value}</span>
            <h3>{subtitle}</h3>
        </div>
    );
}